import { createFileRoute } from '@tanstack/react-router';
import { fallback, zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';

import UpdatePassword from '@/features/auth/components/templates/password/update-password';

const resetPasswordSearchSchema = z.object({
  token: fallback(z.string().uuid(), '').default(''),
});

export const Route = createFileRoute('/(auth)/reset-password')({
  component: UpdatePassword,
  validateSearch: zodValidator(resetPasswordSearchSchema),
});
